import { FC, ImgHTMLAttributes } from "react"
import styled from "styled-components"

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
    widthInPx: number
    heightInPx: number
    shouldFadeEdge: boolean
    saturation?: number
    opacity: number
    offset: Offset
}

type Offset = {
    leftInPx: number
    topInPx: number
}

const WhatWeDoImage: FC<Props> = ({widthInPx, heightInPx, shouldFadeEdge, saturation, opacity, offset, ...props}) => {
    
    return shouldFadeEdge ? <RoundedImage widthInPx={widthInPx}
                                          heightInPx={heightInPx}
                                          saturation={saturation}
                                          opacity={opacity}
                                          offset={offset}
                                          {...props}/>
                          : <Image widthInPx={widthInPx}
                                   heightInPx={heightInPx}
                                   saturation={saturation}
                                   opacity={opacity}
                                   offset={offset}
                                   {...props}/>
}

export default WhatWeDoImage

const Image = styled.img.attrs<{widthInPx: number, heightInPx: number, saturation?: number, opacity: number, offset: Offset}>(p => ({
    style: {
        width: p.widthInPx + "px",
        height: p.heightInPx + "px",
        filter: p.saturation ? `saturate(${(p.saturation ?? 100) * 100}%)` : undefined,
        opacity: p.opacity,
        transform: `translate(${-p.offset.leftInPx}px, ${-p.offset.topInPx}px)`,
    }
}))`
    flex-shrink: 0;
    flex-grow: 0;
    object-fit: contain;
`

const RoundedImage = styled(Image)`
    border-radius: 50% 50%;
    mask-image: radial-gradient(black 55%, transparent 70%);
`